'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'layer-minus';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f5fe';
var svgPathData = 'M512 253.21c0-10.08-5.81-19.13-14.77-23.04L271.9 131.33c-10.06-4.43-21.74-4.43-31.81 0L14.81 230.15C5.81 234.08 0 243.13 0 253.21c0 10.08 5.81 19.13 14.77 23.04L114.5 320l-99.7 43.73C5.81 367.65 0 376.7 0 386.79c0 10.08 5.81 19.13 14.77 23.04l225.32 98.82c5.06 2.22 10.48 3.34 15.9 3.34s10.84-1.11 15.9-3.34l225.29-98.81c9-3.93 14.81-12.98 14.81-23.06 0-10.09-5.81-19.14-14.77-23.06l-99.72-43.75 99.69-43.73c9-3.91 14.81-12.96 14.81-23.03zm-45.19 133.57l-208.06 91.26c-1.81.78-3.74.78-5.48 0L45.23 386.78 156 338.2l84.1 36.89c5.06 2.22 10.48 3.34 15.9 3.34s10.84-1.11 15.9-3.34l84.12-36.9 110.79 48.59zm-208.07-42.31c-1.81.78-3.74.78-5.48 0L45.23 253.21l208.03-91.26c1.81-.78 3.74-.78 5.48 0l208.03 91.26-208.03 91.26zM504 64H296c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8V72c0-4.42-3.58-8-8-8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faLayerMinus = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;